import { render, staticRenderFns } from "./BasePasswordInput.vue?vue&type=template&id=21d96ff0&"
import script from "./BasePasswordInput.vue?vue&type=script&lang=js&"
export * from "./BasePasswordInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports